var shave = require('shave');

function Truncate( el ) {
	var maxHeight = el.getAttribute('data-max-height');
	var maxHeightNumber = ( maxHeight ) ? maxHeight : 60;
	shave( el, maxHeightNumber );
}

module.exports = Truncate;
